var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 111.833C89.0745 111.833 111.833 89.0743 111.833 60.9998C111.833 32.9254 89.0745 10.1665 61 10.1665C32.9255 10.1665 10.1667 32.9254 10.1667 60.9998C10.1667 89.0743 32.9255 111.833 61 111.833Z",
    fill: "#E2453B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86.4167C63.8075 86.4167 66.0834 84.1408 66.0834 81.3333C66.0834 78.5259 63.8075 76.25 61 76.25C58.1926 76.25 55.9167 78.5259 55.9167 81.3333C55.9167 84.1408 58.1926 86.4167 61 86.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 66.0835C59.6518 66.0835 58.3589 65.5479 57.4056 64.5946C56.4522 63.6413 55.9167 62.3484 55.9167 61.0002V40.6668C55.9167 39.3186 56.4522 38.0257 57.4056 37.0724C58.3589 36.1191 59.6518 35.5835 61 35.5835C62.3482 35.5835 63.6412 36.1191 64.5945 37.0724C65.5478 38.0257 66.0834 39.3186 66.0834 40.6668V61.0002C66.0834 62.3484 65.5478 63.6413 64.5945 64.5946C63.6412 65.5479 62.3482 66.0835 61 66.0835Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.62f171c27334e419246ca0af453dfd73.svg";
export { ForwardRef as ReactComponent };